var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.body_show)?_c('div',{staticClass:"bodys"},[_c('div',{staticClass:"calendar_form"},[_c('img',{staticClass:"poster_img",attrs:{"src":_vm.image_url,"alt":""}}),_c('div',{staticClass:"sumbit",on:{"click":function($event){return _vm.$router.push({
            path: '/career_calendar',
            query: {
              activity_id: _vm.activity_id,
              img_show: true
            }
          })}}}),_c('div',{staticClass:"switch",on:{"click":_vm.switch_poster}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }